module.exports = __webpack_public_path__ + "img/1440.b9146ae9.jpg";